import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { createClient } from 'redux/modules/model/client'
import { ClientRegisterForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ClientAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createClient: PropTypes.func.isRequired
  };

  handleSubmit = (values) => {
    const { clientId, history, createClient } = this.props
    return formSubmit(createClient, { ...values })
      .then(() => history.push(ROUTES.CLIENT))
  };

  render() {
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.CLIENT}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new client</PageContentTitle>
          <ClientRegisterForm onSubmit={this.handleSubmit} />
        </Col>
      </Row>
    )
  }
}

export const actions = {
  createClient
}

export default compose(
  withRouter,
  withClientId,
  connect(null, actions),
)(ClientAdd)



// WEBPACK FOOTER //
// ./src/pages/client/client-add/index.js